import store from 'app/store'
import { isAdminRole } from 'core/utils/rbac'
import calcUsageTotalByPath from 'k8s/util/calcUsageTotals'
import { isSelfServiceRole } from 'k8s/util/helpers'

export const calculateNodeUsages = (nodes) => {
  const calcNodesTotals = calcUsageTotalByPath(nodes)
  return {
    compute: calcNodesTotals('usage.compute.current', 'usage.compute.max'),
    memory: calcNodesTotals('usage.memory.current', 'usage.memory.max'),
    disk: calcNodesTotals('usage.disk.current', 'usage.disk.max'),
  }
}
export const isAdmin = () => isAdminRole(store.getState().session)

export const isSelfService = () => isSelfServiceRole(store.getState().session)
